import React from "react";
import Layout from "./components/Layout";
import MainContent from "./components/MainContent";

const Home = () => {
  return (
    <Layout>
      <MainContent />
    </Layout>
  );
};

export default Home;
